module.exports = __webpack_public_path__ + "img/icash-pay.8607c774.svg";